import { browserLogger } from '@widget/utils/datadog';

export function getSearchParam(name: string): string | null {
  try {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(name);
  } catch (error) {
    browserLogger.error(error, 'Error while getting search param.');
    return null;
  }
}
